import Component from "./competence.component";
import { Config } from "./competence.config";
import { watchCompetence as saga } from "./redux/competence.sagas";
import { reducer } from "./redux/competence.reducer";

export default { Component, saga, reducer, config: Config };
